import { multiFranchiseAxios } from '../axios/multiFranchiseAxios'
import {
  CreateTransportPlannerScopePayload,
  RemoveTransportPlannerScopePayload,
  TransportPlannerScopeAuditResponse,
  TransportPlannerScopeListResponse,
  TransportPlannerScopeMutationResponse,
  UpdateTransportPlannerScopePayload,
} from '../../compiler/transportPlannerScope.interface'

const basePath = '/procurement/epod/admin/transport-planner-scopes'

export const APIGetTransportPlannerScopes = async (
  userUuid: string,
  includeInactive = true,
): Promise<TransportPlannerScopeListResponse> => {
  const response = await multiFranchiseAxios.get(`${basePath}/users/${userUuid}`, {
    params: { include_inactive: String(includeInactive) },
  })
  return response.data
}

export const APICreateTransportPlannerScope = async (
  userUuid: string,
  payload: CreateTransportPlannerScopePayload,
): Promise<TransportPlannerScopeMutationResponse> => {
  const response = await multiFranchiseAxios.post(`${basePath}/users/${userUuid}`, payload)
  return response.data
}

export const APIUpdateTransportPlannerScope = async (
  scopeUuid: string,
  payload: UpdateTransportPlannerScopePayload,
): Promise<TransportPlannerScopeMutationResponse> => {
  const response = await multiFranchiseAxios.patch(`${basePath}/${scopeUuid}`, payload)
  return response.data
}

export const APIRemoveTransportPlannerScope = async (
  scopeUuid: string,
  payload: RemoveTransportPlannerScopePayload,
): Promise<TransportPlannerScopeMutationResponse> => {
  const response = await multiFranchiseAxios.delete(`${basePath}/${scopeUuid}`, { data: payload })
  return response.data
}

export const APIGetTransportPlannerScopeAudits = async (
  scopeUuid: string,
): Promise<TransportPlannerScopeAuditResponse> => {
  const response = await multiFranchiseAxios.get(`${basePath}/${scopeUuid}/audits`)
  return response.data
}
